export class TabbedImages extends HTMLElement {
    private buttons: NodeListOf<Element>;
    private images: NodeListOf<Element>;

    constructor() {
        super();
        this.buttons = document.querySelectorAll('[data-button-index]');
        this.images = document.querySelectorAll('[data-image-index]');
        this.bindEvents();
    }

    bindEvents() {
        if (this.buttons.length) {
            for (let i = 0; i < this.buttons.length; i ++) {
                this.buttons[i].addEventListener('click', this.selectNewTab.bind(this))
            }
        }
    }

    selectNewTab(event: Event) {
        const stringIndex = event?.target?.dataset?.buttonIndex;

        if (stringIndex) {
            const index = Number.parseInt(stringIndex);
            for (let i = 0; i < this.buttons.length; i ++) {
                if (i === index) {
                    this.buttons[i].classList.add('active');
                    this.images[i].classList.add('active');
                } else {
                    this.buttons[i].classList.remove('active');
                    this.images[i].classList.remove('active');
                }
            }
        }
    }
}

customElements.define("tabbed-images", TabbedImages);
